// eslint-disable-next-line import/prefer-default-export
import axios from './Axios';

export const getPlans = (): Promise<any> => {
  return axios.get('/plans');
};
